module.exports = __webpack_public_path__ + "img/__icon_BUS.c112f569.svg";